import { PDFDocument } from 'pdf-lib'

// Iframe y URL de la última impresión. No se pueden limpiar apenas se llama a print(): con un PDF,
// el navegador abre el diálogo sin bloquear y si se borra el iframe el diálogo se cierra solo.
// Se limpian recién al iniciar la siguiente impresión.
let lastPrint: { iframe: HTMLIFrameElement, url: string } | undefined

const cleanLastPrint = () => {
    if (!lastPrint) return
    URL.revokeObjectURL(lastPrint.url)
    lastPrint.iframe.remove()
    lastPrint = undefined
}

export const printPdfBlob = (blob: Blob): Promise<void> => {
    cleanLastPrint()

    return new Promise<void>((resolve, reject) => {
        const url = URL.createObjectURL(blob)
        const iframe = document.createElement('iframe')
        // Oculto sin display: none, para que el visor de PDF del navegador cargue el documento
        iframe.style.position = 'fixed'
        iframe.style.right = '0'
        iframe.style.bottom = '0'
        iframe.style.width = '0'
        iframe.style.height = '0'
        iframe.style.border = '0'
        document.body.appendChild(iframe)
        lastPrint = { iframe, url }

        iframe.onload = () => {
            try {
                iframe.contentWindow?.focus()
                iframe.contentWindow?.print()
                resolve()
            } catch (error) {
                cleanLastPrint()
                reject(error)
            }
        }

        iframe.onerror = () => {
            cleanLastPrint()
            reject(new Error('Error al cargar el PDF en el iframe'))
        }

        iframe.src = url
    })
}

export const mergePdfBlobs = async (blobs: Blob[]): Promise<Blob> => {
    const mergedPdf = await PDFDocument.create()
    for (const blob of blobs) {
        const bytes = await blob.arrayBuffer()
        const pdf = await PDFDocument.load(bytes)
        const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices())
        pages.forEach(page => mergedPdf.addPage(page))
    }
    const mergedBytes = await mergedPdf.save()
    return new Blob([mergedBytes], { type: 'application/pdf' })
}
